import { render, staticRenderFns } from "./LoadingH5.vue?vue&type=template&id=74603e5a&scoped=true&"
var script = {}
import style0 from "./LoadingH5.vue?vue&type=style&index=0&id=74603e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74603e5a",
  null
  
)

export default component.exports